export default function transverterFn(len) {
  const i18n = {
    resources: {
      en: {
        translation: {
          productType: "Product Category",
          productType2: "Product Category",
          productModel: "Product Model",
          productWeight: "Product Weight",
          productPeriod: "Production Period",
          productionExplain: "Product Introduction",
          entName: "Company Entity: ",
          ProductInformation: "Product Information",
          ProcessProcess: "Manufacturing Process",
          manufacturingProcess: "Manufacturing Process",
          certificateAddress: "Sustainable products enabled by blockchain",
          ProductCarbonFootprint: "Product Carbon Footprint",
          LifeCycle: "Life cycle",
          SystemBoundary: "System Boundary",
          ProductionQuantity: "Production quantity",
          ProductOverview: "Overview of product carbon footprint distribution",
          ProductDistribution: "Product carbon footprint distribution",
          OverviewProducts: "Overview of product carbon emissions reduction",
          ReductionRatio: "reduction ratio",
          DetailsOfEmissionsReductions:
            "Product carbon emission reduction analysis",
          AboutTitle: "About Us",
          AboutUp: `'Sunliky Technology was established in 2013. The company specializes in the development of polymer and composite materials and application solutions, and provides high-quality products and services for domestic and foreign brands in intelligent terminal, semiconductor, FPC, MLCC, new energy and other industries.
          Sunliky adheres to “taking the customer as the center, to create value for customers”;
          Adhere to “take the striver as the foundation, to build a community of shared and win-win undertakings”;`,
          AboutDown: `Adhere to “fcus on value creation, asist qualified employees to realize their dreams”;
          Firmly implement the differentiated value proposition and TOP strategy, firmly implement the talent capital strategy, firmly promote the research and development of new technologies and new products, and strive to build Sunliky technology into a respected supplier of advanced new materials!`,
          OverviewReduction: "Product carbon emission reduction comparison",
          BasicProduct: "Basic product",
          ImprovedProduct: "Improved product",
          Reduction: "Reduction",
          functionalUnit: "All data are reported in functional units: ",
          CarbonReductionScenarioAnalysis: "Carbon reduction scenario analysis",
          CarbonReductionCertificationEvaluation:
            "Product Carbon Footprint Certification",
          CarbonReductionCertificationEvaluationStart:
            "Carbon reduction certification and assessment",
          ImprovedProductProcess: "Improved product manufacturing process",
          FootprintProducts: "Overview of carbon footprint distribution",
          DetailsCarbonFootprint: "Details of carbon footprint",
          ImprovedProducts:
            "Overview of the carbon footprint of improved products",
          FootprintofimprovedProducts: "Carbon footprint of improved products",
          CompareDetails: "Compare details",
          MORE: "More",
          ViewCertificate: "View Certificate",
          CarbonFootprintAccountingCriteria:
            "Carbon Footprint Accounting Standards",
          ReportingCriteriaReferenced: "Reference Standards for Reporting",
          SystemBoundaryDescription: "System Boundary Description",
          BlockchainBasedEvidenceStorage: "Blockchain-Based Evidence Storage",
        },
      },
      zh: {
        translation: {
          productType: "产品类型",
          productType2: "产品分类",
          productModel: "产品型号",
          productWeight: "产品重量",
          productPeriod: "生产周期",
          productionExplain: "产品简介",
          entName: "公司主体：",
          ProductInformation: "产品信息",
          ProcessProcess: "工艺流程",
          manufacturingProcess: "生产工艺",
          certificateAddress: "区块链可持续产品",
          ProductCarbonFootprint: "产品碳足迹",
          LifeCycle: "生命周期",
          SystemBoundary: "系统边界",
          ProductionQuantity: "生产数量",
          ProductOverview: "产品碳足迹分布概览",
          ProductDistribution: "产品碳足迹分布",
          OverviewProducts: "产品碳减排概览",
          DetailsOfEmissionsReductions: "产品碳减排分析",
          AboutTitle: "关于我们",
          AboutUp: `耀阳科技成立于2013年，公司专业、专注于高分子及其复合材料开发与应用解决方案研发，为智能终端、半导体、FPC、MLCC、 新能源等多行业的国内外品牌商提供优质产品与服务。
          耀阳坚持以客户为中心，为客户创造价值；
          坚持以奋斗者为本，打造共享共赢事业共同体；`,
          AboutDown: `坚持以价值创造为本，助合格员工实现理想；
          坚定贯彻差异化价值主张和TOP战略，坚定实施人才资本战略，坚定推动新技术、新产品研发，努力将耀阳科技打造成受人尊敬的先进新材料供应商！`,
          OverviewReduction: "产品碳减排对比",
          BasicProduct: "基础产品",
          ImprovedProduct: "改良产品",
          Reduction: "减碳量",
          functionalUnit: "所有数据均采用功能单位：",
          CarbonReductionScenarioAnalysis: "碳减排场景分析",
          CarbonReductionCertificationEvaluation: "产品碳足迹认证证书",
          CarbonReductionCertificationEvaluationStart: "碳减排认证与评估",
          ImprovedProductProcess: "改良产品工艺流程",
          FootprintProducts: "改良产品碳足迹分布概览",
          DetailsCarbonFootprint: "碳足迹详情",
          ReductionRatio: "减排比例(%)",
          ImprovedProducts: "改良产品碳足迹概览",
          FootprintofimprovedProducts: "改良产品碳足迹",
          CompareDetails: "对比详情",
          MORE: "更多",
          ViewCertificate: "查看证书",
          CarbonFootprintAccountingCriteria: "碳足迹核算标准",
          ReportingCriteriaReferenced: "报告参考标准",
          SystemBoundaryDescription: "系统边界说明",
          BlockchainBasedEvidenceStorage: "区块链存证",
        },
      },
    },
  };
  const resources = i18n.resources;
  return len ? resources.zh.translation : resources.en.translation;
}
